module.exports = [
    {
        name: 'Mazda 3 Sedan',
        nicename: '3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885836&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885836&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037110/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885843&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037092/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885843&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda3_4dr_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885865&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037224/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885865&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda3_4dr_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885836&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885836&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037110/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885850&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885850&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037234/skeleton.gif'
            }
        }
    },
    {
        name: 'Mazda 6',
        nicename: '6',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885838&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885838&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037122/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885845&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037102/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885845&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda6_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885867&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037220/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885867&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda6_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885838&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885838&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037122/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885852&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885852&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037230/skeleton.gif'
            }
        }
    }
];


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/constants/sedan.js
// module id = 63
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14